
import ViewBox from 'vux/src/components/view-box/index.vue'


export default {
  components: {
    ViewBox
  }
}




// WEBPACK FOOTER //
// ./src/App.vue